"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const index_1 = require("../index");
class PredicateListValue extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isEditingIndexText: null,
        };
    }
    componentDidUpdate(prevProps) {
        if (this.props.values.length > prevProps.values.length) {
            const body = document.getElementById('predicate-builder-body');
            body.scrollTop = body.offsetHeight;
        }
    }
    render() {
        const { values, ordered, handleValueUpdate, device, minArrLength } = this.props;
        const { Fragment } = React;
        const { isEditingIndexText } = this.state;
        const setEllipsis = (value, index) => {
            return isEditingIndexText == null || isEditingIndexText !== index
                ? {
                    whiteSpace: 'nowrap',
                    overflow: value == undefined ? null : 'hidden',
                    textOverflow: 'ellipsis',
                }
                : {};
        };
        return (React.createElement(Fragment, null,
            values.map((value, index) => (React.createElement("div", { style: {
                    alignItems: 'center',
                    display: 'flex',
                    minHeight: device === 'Mobile' ? 72 : 56,
                    justifyContent: 'space-between',
                    boxSizing: 'border-box',
                    borderBottom: `1px solid ${index_1.titanium}`,
                }, onClick: () => this.setState({
                    isEditingIndexText: index,
                }), key: index },
                React.createElement("div", { style: {
                        display: 'flex',
                        alignItems: 'center',
                    } },
                    React.createElement("div", { style: {
                            marginLeft: 8,
                        } }, ordered ? (React.createElement(index_1.Badge, { color: index_1.charcoal, text: `${index + 1}.` })) : (React.createElement("div", { style: {
                            background: index_1.charcoal,
                            height: 6,
                            width: 6,
                            borderRadius: 3,
                        } }))),
                    React.createElement("div", { style: {
                            padding: device === 'Mobile' ? '22px 0' : '14px 0',
                            display: 'flex',
                            alignItems: 'center',
                        } },
                        React.createElement(index_1.Text, { text: value == null ? '' : value, textStyle: Object.assign({ marginLeft: 16, width: device === 'Mobile' ? 'calc(100vw - 110px)' : 292 }, setEllipsis(value, index)), placeholder: true, placeholderText: "Value", size: "medium", id: `predicate-list-value-input-${index}`, contentEditable: this.state.isEditingIndexText === index, onInputChange: (str) => {
                                let newValues = [...values];
                                newValues[index] = str.length === 0 ? null : str;
                                handleValueUpdate(newValues);
                            }, handleChange: (str) => {
                                this.setState({
                                    isEditingIndexText: null,
                                });
                            } }))),
                values.length !== minArrLength && (React.createElement("div", { style: {
                        flex: '0 0 auto',
                    } },
                    React.createElement(index_1.CircleCloseIcon, { fill: index_1.aquamarine, onClick: (e) => {
                            e.stopPropagation();
                            handleValueUpdate([...values.slice(0, index), ...values.slice(index + 1)]);
                        } })))))),
            React.createElement(index_1.PlusSquareIcon, { onClick: () => {
                    handleValueUpdate(values.concat(null));
                }, fill: index_1.turquoise, style: {
                    marginTop: 16,
                    marginBottom: 16,
                } })));
    }
}
PredicateListValue.defaultProps = {
    values: [null, null, null],
    minArrLength: 1,
};
exports.default = PredicateListValue;
